var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_c('b-card', {
    staticClass: "border mb-0 mt-1",
    staticStyle: {
      "max-height": "70vh"
    },
    attrs: {
      "header-tag": "header",
      "border-variant": "info",
      "header-bg-variant": "light-info",
      "header-class": "p-1",
      "no-body": ""
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "m-0 text-uppercase font-weight-bolder"
        }, [_vm._v(" " + _vm._s(_vm.$t('agency.agencyF3.title')) + " ")])];
      },
      proxy: true
    }])
  }, [_c('b-table', {
    ref: "refEmployeeListTable",
    staticClass: "position-relative",
    staticStyle: {
      "max-height": "55vh"
    },
    attrs: {
      "sticky-header": true,
      "items": _vm.agencyData,
      "responsive": "",
      "fields": _vm.tableAgenciesF3,
      "primary-key": "id",
      "show-empty": "",
      "empty-text": _vm.$t('noMatchingResult'),
      "no-border-collapse": "",
      "small": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.tableAgenciesF3, function (column) {
      return {
        key: "head(".concat(column.key, ")"),
        fn: function fn(data) {
          return [_c('span', {
            key: column.label,
            staticClass: "text-dark text-nowrap"
          }, [_vm._v(" " + _vm._s(_vm.$t("agency.agencyF3.columns.".concat(data.label))) + " ")])];
        }
      };
    }), {
      key: "cell(no)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(data.index + 1))])];
      }
    }, {
      key: "cell(agcCode)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "text-nowrap"
        }, [_c('b-link', {
          staticClass: "font-weight-bold d-block text-nowrap text-info",
          attrs: {
            "to": {
              name: 'apps-agencies-edit',
              params: {
                id: data.item.id
              }
            },
            "disabled": !_vm.canAccess('employee.detailEmployee')
          }
        }, [_c('span', {
          staticClass: "align-text-top text-capitalize font-weight-bold"
        }, [_vm._v(" " + _vm._s(data.item.agencyCode) + " ")])])], 1)];
      }
    }, {
      key: "cell(agcInfo)",
      fn: function fn(data) {
        return [_c('b-media', {
          staticClass: "d-flex-center",
          attrs: {
            "vertical-align": "center"
          },
          scopedSlots: _vm._u([{
            key: "aside",
            fn: function fn() {
              return [_c('b-avatar', {
                attrs: {
                  "size": "40",
                  "src": data.item.avatar,
                  "text": _vm.avatarText("".concat(data.item.agencyName)),
                  "variant": "light-primary"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_c('h5', [_c('span', {
          staticClass: "font-weight-bold d-block text-nowrap"
        }, [_vm._v(" " + _vm._s(data.item.agencyName) + " ")])])])];
      }
    }, {
      key: "cell(owner)",
      fn: function fn(data) {
        return [_c('b-media', {
          staticClass: "d-flex-center",
          attrs: {
            "no-body": ""
          }
        }, [_c('b-media-aside', {
          staticClass: "mr-1"
        }, [_c('b-avatar', {
          attrs: {
            "rounded": "",
            "variant": "light-info",
            "size": "34"
          }
        }, [_c('feather-icon', {
          attrs: {
            "size": "18",
            "icon": "TagIcon"
          }
        })], 1)], 1), _c('b-media-body', [_c('h6', {
          staticClass: "mb-0 text-nowrap"
        }, [_vm._v(" " + _vm._s(data.item.agencyOwner.name || 'N/A') + " ")])])], 1)];
      }
    }, {
      key: "cell(email)",
      fn: function fn(data) {
        return [_c('b-media', {
          staticClass: "d-flex-center",
          attrs: {
            "no-body": ""
          }
        }, [_c('b-media-aside', {
          staticClass: "mr-1"
        }, [_c('b-avatar', {
          attrs: {
            "rounded": "",
            "variant": "light-info",
            "size": "34"
          }
        }, [_c('feather-icon', {
          attrs: {
            "size": "18",
            "icon": "MailIcon"
          }
        })], 1)], 1), _c('b-media-body', [_c('h6', {
          staticClass: "mb-0 text-nowrap"
        }, [_c('span', [_vm._v(_vm._s(data.item.emailAddress || 'N/A'))])]), _c('small', {
          staticClass: "text-nowrap"
        }, [_vm._v(" " + _vm._s(data.item.createdBy ? "".concat(data.item.createdBy.firstName, " ").concat(data.item.createdBy.lastName) : ''))])])], 1)];
      }
    }, {
      key: "cell(created)",
      fn: function fn(data) {
        return [_c('b-media', {
          staticClass: "d-flex-center",
          attrs: {
            "no-body": ""
          }
        }, [_c('b-media-aside', {
          staticClass: "mr-1"
        }, [_c('b-avatar', {
          attrs: {
            "rounded": "",
            "variant": "light-info",
            "size": "34"
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "ClockIcon",
            "size": "18"
          }
        })], 1)], 1), _c('b-media-body', [_c('h6', {
          staticClass: "mb-0 text-nowrap"
        }, [_vm._v(" " + _vm._s(_vm.dateTime(data.item.createdAt)) + " ")]), _c('small', {
          staticClass: "text-nowrap"
        }, [_vm._v(" " + _vm._s(data.item.createdBy ? "".concat(data.item.createdBy.firstName, " ").concat(data.item.createdBy.lastName) : ''))])])], 1)];
      }
    }, {
      key: "cell(updated)",
      fn: function fn(data) {
        return [_c('b-media', {
          staticClass: "d-flex-center",
          attrs: {
            "no-body": ""
          }
        }, [_c('b-media-aside', {
          staticClass: "mr-1"
        }, [_c('b-avatar', {
          attrs: {
            "rounded": "",
            "variant": "light-info",
            "size": "34"
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EditIcon",
            "size": "18"
          }
        })], 1)], 1), _c('b-media-body', [_c('h6', {
          staticClass: "mb-0 text-nowrap"
        }, [_vm._v(" " + _vm._s(_vm.dateTime(data.item.updatedAt)) + " ")]), _c('small', {
          staticClass: "text-nowrap"
        }, [_vm._v(" " + _vm._s(data.item.updatedBy ? "".concat(data.item.updatedBy.firstName, " ").concat(data.item.updatedBy.lastName) : ''))])])], 1)];
      }
    }], null, true)
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }